import React, { useEffect, useRef } from "react";
import "./index.css";
import clip from "./img/deniro.mp4";
import poster from "./img/deniro-poster.jpg";

const Deniro = () => {
  const videoRef = useRef(null);

  // Pause when scrolling out of view, never auto-play
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          videoRef.current?.pause();
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="section-styles-deniro" id="deniro">
      <h2 className="press-header-deniro">
        Robert De Niro Talks about Laura on the Today Show
      </h2>
      <div className="video-container">
        <video
          ref={videoRef}
          controls
          preload="metadata"
          poster={poster}
          src={clip}
          className="react-player"
        />
      </div>
    </section>
  );
};

export default Deniro;
